var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pintuan-skin-one", style: { padding: _vm.imgActPadding } },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: {
            "element-loading-text": "拼命加载中",
            "element-loading-spinner": "el-icon-loading",
          },
        },
        _vm._l(_vm.goodsList, function (goods, index) {
          return _c("div", { key: index, staticClass: "goods-item flex" }, [
            _c("img", {
              staticClass: "goods-img",
              attrs: { src: goods.image },
              on: {
                error: function ($event) {
                  return _vm.imgError(index)
                },
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "goods-info" }, [
              _c("div", { staticClass: "title ellipsis2" }, [
                _c(
                  "span",
                  {
                    staticClass: "num-tag",
                    style: { backgroundColor: _vm.propsData.pincolor || "red" },
                  },
                  [_vm._v(_vm._s(goods.peopleStr))]
                ),
                _vm._v(_vm._s(goods.combinationName)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex flex-btw" }, [
                _c("div", { staticClass: "flex" }, [
                  _c("div", { staticStyle: { "margin-right": "2px" } }, [
                    _vm._v("拼团价"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { style: { color: _vm.propsData.pincolor || "red" } },
                    [_vm._v(_vm._s(goods.combinationPrice || "--"))]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "pin-btn",
                    style: { backgroundColor: _vm.propsData.pincolor || "red" },
                  },
                  [_vm._v("参与拼团")]
                ),
              ]),
            ]),
          ])
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }